/*
* @描述: 新建工单
* @版本: 1.0
* @作者: 冯强
* @创建时间: 2025-02-20 18:28:23
*/
<template>
    <div class="page_container">
        <div class="page_header">
            <div>
                <span class="return_btn_wrap" @click="handleClickReturn">
                    <i class="el-icon-arrow-left"></i>
                    <span>返回</span>
                </span>
                <span class="line"></span>
                <span class="page_title">新建工单</span>
            </div>
        </div>
        <div class="page_body">
            <div class="form_field_wrap">
                <div class="custom_form_outer_wrap">
                    <CustomFormPc v-if="formInfoList.length"
                                  ref="workOrderForm"
                                  :field_form="'work_orders'"
                                  :field_list="formInfoList"
                                  :is_form_module="true"
                                  @submit-form="submitWorkOrderFormData"/>
                    <div v-if="isApproval===1" class="add_approval_select_process">
                        <div class="page_little_title">
                            <span class="title">审批流程</span>
                        </div>
                        <approveProcessSelect ref="approveProcessSelectRef"
                                              :approval_node_list="approval_node_list">
                        </approveProcessSelect>
                    </div>
                </div>
                <div class="custom_form_footer">
                    <el-button size="small" @click="handleClickCancel">取消</el-button>
                    <el-button size="small" type="primary" @click="handleClickConfirm">确定</el-button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import {getApprovalNodes, getFormFields, workOrderAdd, workOrderSetDetail} from "@/api";
import CustomFormPc from "@/components/pComponents/CustomFormPc";
import approveProcessSelect from "@/components/pComponents/approveProcessSelect";
import {EventBus} from '@/utils/eventBus';
import {removeTag} from "@/utils";

export default {
    name: "WorkOrderAdd",
    mixins: [],
    data() {
        return {
            formInfoList: [],
            isApproval: 0,
            mode: 0,
            approval_node_list: []
        }
    },
    created() {
        this._getFromFields()
    },
    components: {CustomFormPc, approveProcessSelect},
    computed: {},
    mounted() {

    },
    methods: {
        handleClickReturn() {
            removeTag(this.$route)
            this.$router.go(-1)
        },

        _getFromFields() {
            this.loading = true
            getFormFields({
                field_form: 'workorders'
            }).then(res => {
                if (res.code === 200) {
                    this.formInfoList = res.data
                    workOrderSetDetail().then(res => {
                        this.isApproval = res.data.is_create_approve
                        this.mode = res.data.mode
                        if (this.isApproval === 1) {
                            getApprovalNodes({
                                approval_type: 'workorder_create',
                            }).then(res => {
                                if (res.code === 200) {
                                    this.approval_node_list = res.data
                                    this.$refs.approveProcessSelectRef.set_approval_node_list(res.data)
                                } else {
                                    this.$message.error(res.message)
                                }
                                this.loading = false
                            }).catch(() => {
                                this.loading = false
                            })
                        }
                    })
                } else {
                    this.$message.error(res.message)
                }
                this.loading = false
            }).catch(() => {
                this.loading = false
            })
        },

        submitWorkOrderFormData(data) {
            if (this.isApproval === 1 && !this.$refs.approveProcessSelectRef.handleClickPublish()) return false
            let params = {
                ...data,
                node_list: this.approval_node_list,
                mode: this.mode
            }
            const workorder_role_data = this.formInfoList.filter(field=> field.field_type === 'workorder_role')
            workorder_role_data.forEach(field=> {
                if(field.extend.relate_role_type === 'assign_user') {
                    params.assign_uids = data[field.field_key]?.value || []
                } else if(field.extend.relate_role_type === 'processing_user') {
                    params.processing_uids = data[field.field_key]?.value || []
                }
            })
            workOrderAdd(params).then(res => {
                if (res.code === 200) {
                    removeTag(this.$route)
                    EventBus.$emit('workOrderAddUpdated');
                    this.$message.success('新建成功')
                    this.$router.go(-1)
                }
            })
        },

        handleClickCancel() {
            removeTag(this.$route)
            this.$router.back()
        },

        handleClickConfirm() {
            this.$refs.workOrderForm.handleClickPublish()
        }
    },
}
</script>
<style lang="scss" scoped>
    .page_container {
        background-color: #EDF0F4;

        .page_header_wrap {
            padding: 12px;
            background-color: #FFFFFF;
        }

        .page_body {
            padding: 4px 0;
        }

        .form_field_wrap {
            width: 680px;
            height: 100%;
            margin: 0 auto;
            border-radius: 8px;
            background: #FFFFFF;

            .custom_form_outer_wrap {
                width: 100%;
                height: calc(100% - 52px);
                padding: 24px;
                overflow-y: auto;
            }

            .custom_form_footer {
                text-align: center;
                padding: 10px 0;
                box-shadow: 0px -1px 0px rgba(0, 0, 0, 0.08);
            }
        }
    }
</style>
